<div class="page-content-bottom selection-toolbar">
    <div class="justify-content">
        <div class="flex-start">
            <div class="form-flex border-bottom">
                <div class="form-flex-row dual-row">
                    <div class="form-flex-label" *ngIf="config.selectType=='citationEmbed' && config.embedMode=='brief'">
                        <label for="linkName">Link label:</label>
                    </div>
                    <div class="form-flex-input padding-right" *ngIf="config.selectType=='citationEmbed' &&  config.embedMode=='brief'">
                        <input id="linkLabel" #linkLabel type="text" [(ngModel)]="config.linkLabel" class="form-control input-bg" value="{{'lti.embed.link.label.default' | translate}}">
                    </div>
                    <div class="form-flex-label" tabindex="0" *ngIf="config.selectType=='citationEmbed' &&  config.embedMode=='brief'">
                        <label for="exportStyle">{{'export.label' | translate}}</label>
                    </div>
                    <div class="form-flex-input padding-right" *ngIf="config.selectType=='citationEmbed' &&  config.embedMode=='brief'">
                        <select [(ngModel)]="config.displayStyle" id="exportStyle" class="form-control inverse-select">
                            <option *ngFor="let i of displayStyles" [ngValue]="i">{{i.label}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-end">
            <button class="btn btn-primary" (click)="addItems()" tabindex="0" id="selectItems" attr.aria-label="{{'collection.new.search.add' | translate}}" *ngIf="config.selectType=='citationEmbed'">
                {{'collection.new.search.add' | translate}}
            </button>
            <button class="btn btn-primary" (click)="selectLink()" tabindex="0" id="selectItems" attr.aria-label="{{'collection.new.search.add' | translate}}" *ngIf="config.selectType=='linkSelection'">
                {{'citation.link.select' | translate}}
            </button>
            <div class="label-Declined" role="alert" aria-live="assertive" *ngIf="errorExists">
                {{'lti.embed.error.message' | translate}}
            </div>
        </div>
    </div>
</div>